export const FETCH_SUGGESTED_COMPETITORS_REQUEST =
  "FETCH_SUGGESTED_COMPETITORS_REQUEST";
export const FETCH_SUGGESTED_COMPETITORS_SUCCESS =
  "FETCH_SUGGESTED_COMPETITORS_SUCCESS";
export const FETCH_SUGGESTED_COMPETITORS_FAILURE =
  "FETCH_SUGGESTED_COMPETITORS_FAILURE";

export const fetchSuggestedCompetitorsRequest = (params) => ({
  type: FETCH_SUGGESTED_COMPETITORS_REQUEST,
  payload: params, // optional (client, account, etc.)
});

export const fetchSuggestedCompetitorsSuccess = (data) => ({
  type: FETCH_SUGGESTED_COMPETITORS_SUCCESS,
  payload: data,
});

export const fetchSuggestedCompetitorsFailure = (error) => ({
  type: FETCH_SUGGESTED_COMPETITORS_FAILURE,
  payload: error,
});
